import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { checkLoggedUser, getUser } from '../../../redux/usersRedux';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import {
  Box,
  Button,
  Chip,
  FormControlLabel,
  MenuItem,
  Pagination,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Checkbox,
  Snackbar,
  Alert,
  AlertTitle,
} from '@mui/material';
import {
  deleteReportPZ04Request,
  getReportsPZ04,
  loadReportsPZ04ByUserWarehouse,
  loadReportsPZ04Request,
} from '../../../redux/reportsPZ04Redux';
import { Link } from 'react-router-dom';
import { dateFormatter } from '../../../utils/dateFormatter';
import { changeStatusName } from '../../../utils/changeStatusName';
import { ReadMore } from '@mui/icons-material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
const ReportPZ04ListForm = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const user = useSelector((state) => getUser(state));
  const [activePage, setActivePage] = useState(1);
  const [itemPage, setItemPage] = useState(30);
  const [pageCount, setPageCount] = useState(0);
  const reports = useSelector((state) => getReportsPZ04(state));
  const [reportsFiltered, setReportsFiltered] = useState('');
  const [newReport, setNewReport] = useState(true);
  const [inProgressReport, setInProgressReport] = useState(true);
  const [doneReport, setDoneReport] = useState(false);
  const [dateFrom, setDateFrom] = useState(undefined);
  const [dateTo, setDateTo] = useState(undefined);
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [alert, setAlert] = useState(false);

  useEffect(() => {
    const start = async () => {
      await dispatch(checkLoggedUser());
      if (
        user.users.role === 'KIER_DS_REKLAMACJI' ||
        user.users.role === 'ADMIN'
      ) {
        await dispatch(loadReportsPZ04Request());
      } else {
        await dispatch(loadReportsPZ04ByUserWarehouse(user.users.warehouse));
      }
      setLoading(false);
    };
    start();
  }, [dispatch]);

  useEffect(() => {
    setPageCount(Math.ceil(reports.length / itemPage));
  }, [reports, itemPage]);

  const handleChangePage = (event, value) => {
    setActivePage(value);
  };

  const handleItemsPage = (value) => {
    setItemPage(value);
    if (activePage > Math.ceil(reports.length / value)) {
      setActivePage(Math.ceil(reports.length / value));
    }
  };

  const handleSubmit = async (id) => {
    setAlert(true);
    const res = await dispatch(deleteReportPZ04Request(id));

    setDeleteAlert(res.status);
  };

  const handleNewChange = (status) => {
    switch (status) {
      case 'new':
        setNewReport(!newReport);
        break;
      case 'progress':
        setInProgressReport(!inProgressReport);
        break;
      case 'done':
        setDoneReport(!doneReport);
        break;
      default:
        break;
    }
  };

  const handleClose = () => {
    setAlert(false);
  };

  const handleDateTo = (date) => {
    if (date === undefined) return setDateTo(undefined);
    const newDateTo = new Date(date);
    newDateTo.setHours(23, 59, 59, 999);

    setDateTo(newDateTo);
  };

  const handleDateFrom = (date) => {
    if (date === undefined) return setDateFrom(undefined);
    const newDateFrom = new Date(date);
    newDateFrom.setHours(0, 0, 0, 0);
    setDateFrom(newDateFrom);
  };

  const handleChangeType = (typeRep) => {
    if (typeRep === 'KWARANTANNA') {
      return 'KW';
    } else if (typeRep === 'PODEJRZENIE_NIEZGODNOSCI') {
      return 'PN';
    } else if (typeRep === 'RAPORT_NIEZGODNOSCI') {
      return 'RN';
    }
  };

  const changeFirstLetterToUpper = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  if (!loading) {
    return (
      <>
        {deleteAlert === 200 && (
          <Snackbar open={alert} autoHideDuration={6000} onClose={handleClose}>
            <Alert
              variant="filled"
              onClose={handleClose}
              severity="success"
              sx={{ width: '100%' }}
            >
              <AlertTitle>Success</AlertTitle>
              Pomyślnie usunięto niezgodność
            </Alert>
          </Snackbar>
        )}
        {deleteAlert === 500 && (
          <Snackbar open={alert} autoHideDuration={6000} onClose={handleClose}>
            <Alert
              variant="filled"
              onClose={handleClose}
              severity="error"
              sx={{ width: '100%' }}
            >
              <AlertTitle>Error</AlertTitle>
              {t('common.serverError')}
            </Alert>
          </Snackbar>
        )}
        <Select
          sx={{ mb: 3 }}
          labelId="select-count"
          id="select-page-count"
          value={itemPage}
          onChange={(e) => handleItemsPage(e.target.value)}
        >
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={30}>30</MenuItem>
          <MenuItem value={50}>50</MenuItem>
          <MenuItem value={100}>100</MenuItem>
        </Select>
        <Tooltip title={t('pz04.tooltipFilter')}>
          <TextField
            sx={{ mb: 3, ml: 3, mr: 1 }}
            label={t('pz05.filter')}
            value={reportsFiltered}
            variant="outlined"
            onChange={(e) => setReportsFiltered(e.target.value)}
          />
        </Tooltip>
        <LocalizationProvider adapterLocale="pl" dateAdapter={AdapterDayjs}>
          <DatePicker
            label={t('pz05.report.dateFrom')}
            format="DD.MM.YYYY"
            views={['year', 'month', 'day']}
            value={dateFrom === undefined ? 'DD.MM.YYYY' : dayjs(dateFrom)}
            onChange={(newValue) => {
              handleDateFrom(newValue);
            }}
            slotProps={{
              field: {
                clearable: true,
                onChange: () => {
                  handleDateFrom(undefined);
                },
              },
              textField: {
                error: false,
              },
            }}
            sx={{ mr: 2, mb: { xs: 2 }, width: { xs: '100%', md: '250px' } }}
          />
          <DatePicker
            label={t('pz05.report.dateTo')}
            format="DD.MM.YYYY"
            views={['year', 'month', 'day']}
            value={dateTo === undefined ? 'DD.MM.YYYY' : dayjs(dateTo)}
            onChange={(newValue) => {
              handleDateTo(newValue);
            }}
            slotProps={{
              field: {
                clearable: true,
                onChange: () => {
                  handleDateTo(undefined);
                },
              },
              textField: {
                error: false,
              },
            }}
            sx={{
              mr: 2,
              width: { xs: '100%', md: '250px' },
              borderColor: '',
            }}
          />
        </LocalizationProvider>

        <FormControlLabel
          sx={{ ml: 2 }}
          label={t('pz05.statusNew')}
          control={
            <Checkbox
              color="primary"
              checked={newReport}
              onChange={() => handleNewChange('new')}
            />
          }
        />
        <FormControlLabel
          sx={{ ml: 2 }}
          label={t('pz05.statusInProgress')}
          control={
            <Checkbox
              sx={{ '&.Mui-checked': { color: 'orange' } }}
              checked={inProgressReport}
              onChange={() => handleNewChange('progress')}
            />
          }
        />
        <FormControlLabel
          sx={{ ml: 2 }}
          label={t('pz05.statusCompleted')}
          control={
            <Checkbox
              color="success"
              checked={doneReport}
              onChange={() => handleNewChange('done')}
            />
          }
        />
        <TableContainer
          component={Paper}
          sx={{ border: '1px solid black', width: '100%' }}
        >
          <Table sx={{ minWidth: 650 }} size="small" aria-label="report table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: '20px' }}></TableCell>
                <TableCell>{t('pz04.list.reportNumber')}</TableCell>
                <TableCell>{t('pz04.list.type')}</TableCell>
                <TableCell>{t('pz04.list.reason')}</TableCell>
                <TableCell>{t('pz04.list.orderNumber')}</TableCell>
                <TableCell>{t('pz04.list.index')}</TableCell>
                <TableCell>{t('pz04.list.materialName')}</TableCell>
                <TableCell>{t('pz04.list.batch')}</TableCell>
                <TableCell>{t('pz04.list.BBT')}</TableCell>
                <TableCell>{t('pz04.list.dateMicroCulture')}</TableCell>
                <TableCell>{t('pz04.list.dateCreated')}</TableCell>
                <TableCell>{t('pz04.list.status')}</TableCell>
                {(user.users.role === 'LABO' ||
                  user.users.role === 'ADMIN') && (
                  <TableCell align="center">{t('account.action')}</TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {reports.length > 0 &&
                reports
                  .slice((activePage - 1) * itemPage, activePage * itemPage)
                  .map((el) => {
                    if (reportsFiltered !== '') {
                      if (
                        (el.reportNumber
                          .toLowerCase()
                          .includes(reportsFiltered.toLowerCase()) ||
                          el.typeReport
                            .toLowerCase()
                            .includes(reportsFiltered.toLowerCase()) ||
                          el.orderBatch
                            .toLowerCase()
                            .includes(reportsFiltered.toLowerCase()) ||
                          el.reason
                            .toLowerCase()
                            .includes(reportsFiltered.toLowerCase()) ||
                          el.orderNumber
                            .toLowerCase()
                            .includes(reportsFiltered.toLowerCase()) ||
                          el.orderProduct.materialNumber
                            .toString()
                            .toLowerCase()
                            .includes(reportsFiltered.toLowerCase()) ||
                          el.orderProduct.description
                            .toLowerCase()
                            .includes(reportsFiltered.toLowerCase())) &&
                        ((el.statusReport === 'NEW' && newReport) ||
                          (el.statusReport === 'IN_PROGRESS' &&
                            inProgressReport) ||
                          (el.statusReport === 'DONE' && doneReport))
                      ) {
                        if (dateFrom !== undefined && dateTo !== undefined) {
                          if (
                            new Date(el.createdAt) >= dateFrom &&
                            new Date(el.createdAt) <= dateTo
                          ) {
                            return (
                              <TableRow hover key={el.id}>
                                <TableCell sx={{ width: '20px' }}>
                                  <Button
                                    sx={{ color: '#C09A53' }}
                                    component={Link}
                                    to={`/details-pz04/${el.id}`}
                                  >
                                    <ReadMore />
                                  </Button>
                                </TableCell>
                                <TableCell>{el.reportNumber}</TableCell>
                                <TableCell>
                                  {handleChangeType(el.typeReport)}
                                </TableCell>
                                <TableCell>
                                  {changeFirstLetterToUpper(el.reason)}
                                </TableCell>
                                <TableCell>{el.orderNumber}</TableCell>
                                <TableCell>
                                  {el.orderProduct.materialNumber}
                                </TableCell>
                                <TableCell>
                                  {el.orderProduct.description}
                                </TableCell>
                                <TableCell>{el.orderBatch}</TableCell>
                                <TableCell>{el.BBT}</TableCell>
                                <TableCell>
                                  {el.microCulture ? 'Prawda' : 'Brak'}
                                </TableCell>
                                <TableCell>
                                  {dateFormatter(el.createdAt)}
                                </TableCell>
                                {el.statusReport === 'DONE' && (
                                  <TableCell>
                                    <Chip
                                      label={changeStatusName(el.statusReport)}
                                      color="success"
                                    />
                                  </TableCell>
                                )}
                                {el.statusReport === 'IN_PROGRESS' && (
                                  <TableCell>
                                    <Chip
                                      label={changeStatusName(el.statusReport)}
                                      sx={{ backgroundColor: 'orange' }}
                                    />
                                  </TableCell>
                                )}
                                {el.statusReport === 'NEW' && (
                                  <TableCell>
                                    <Chip
                                      label={changeStatusName(el.statusReport)}
                                      color="primary"
                                    />
                                  </TableCell>
                                )}
                                {(user.users.role === 'LABO' ||
                                  user.users.role === 'ADMIN') && (
                                  <TableCell align="center">
                                    <Box display="flex">
                                      {(el.statusReport === 'NEW' ||
                                        user.users.role === 'ADMIN') && (
                                        <Button
                                          sx={{ color: 'orange', p: '0' }}
                                          component={Link}
                                          to={`/edit-pz04/${el.id}`}
                                        >
                                          <EditIcon />
                                        </Button>
                                      )}
                                      {(el.statusReport === 'NEW' ||
                                        user.users.role === 'ADMIN') && (
                                        <Button
                                          sx={{ color: 'red', p: '0' }}
                                          onClick={() => handleSubmit(el.id)}
                                        >
                                          <DeleteIcon />
                                        </Button>
                                      )}
                                    </Box>
                                  </TableCell>
                                )}
                              </TableRow>
                            );
                          }
                        } else if (dateTo !== undefined) {
                          if (new Date(el.createdAt) <= dateTo) {
                            return (
                              <TableRow hover key={el.id}>
                                <TableCell sx={{ width: '20px' }}>
                                  <Button
                                    sx={{ color: '#C09A53' }}
                                    component={Link}
                                    to={`/details-pz04/${el.id}`}
                                  >
                                    <ReadMore />
                                  </Button>
                                </TableCell>
                                <TableCell>{el.reportNumber}</TableCell>
                                <TableCell>
                                  {handleChangeType(el.typeReport)}
                                </TableCell>
                                <TableCell>
                                  {changeFirstLetterToUpper(el.reason)}
                                </TableCell>
                                <TableCell>{el.orderNumber}</TableCell>
                                <TableCell>
                                  {el.orderProduct.materialNumber}
                                </TableCell>
                                <TableCell>
                                  {el.orderProduct.description}
                                </TableCell>
                                <TableCell>{el.orderBatch}</TableCell>
                                <TableCell>{el.BBT}</TableCell>
                                <TableCell>
                                  {el.microCulture ? 'Tak' : 'Nie'}
                                </TableCell>
                                <TableCell>
                                  {dateFormatter(el.createdAt)}
                                </TableCell>
                                {el.statusReport === 'DONE' && (
                                  <TableCell>
                                    <Chip
                                      label={changeStatusName(el.statusReport)}
                                      color="success"
                                    />
                                  </TableCell>
                                )}
                                {el.statusReport === 'IN_PROGRESS' && (
                                  <TableCell>
                                    <Chip
                                      label={changeStatusName(el.statusReport)}
                                      sx={{ backgroundColor: 'orange' }}
                                    />
                                  </TableCell>
                                )}
                                {el.statusReport === 'NEW' && (
                                  <TableCell>
                                    <Chip
                                      label={changeStatusName(el.statusReport)}
                                      color="primary"
                                    />
                                  </TableCell>
                                )}
                                {(user.users.role === 'LABO' ||
                                  user.users.role === 'ADMIN') && (
                                  <TableCell align="center">
                                    <Box display="flex">
                                      {(el.statusReport === 'NEW' ||
                                        user.users.role === 'ADMIN') && (
                                        <Button
                                          sx={{ color: 'orange', p: '0' }}
                                          component={Link}
                                          to={`/edit-pz04/${el.id}`}
                                        >
                                          <EditIcon />
                                        </Button>
                                      )}
                                      {(el.statusReport === 'NEW' ||
                                        user.users.role === 'ADMIN') && (
                                        <Button
                                          sx={{ color: 'red', p: '0' }}
                                          onClick={() => handleSubmit(el.id)}
                                        >
                                          <DeleteIcon />
                                        </Button>
                                      )}
                                    </Box>
                                  </TableCell>
                                )}
                              </TableRow>
                            );
                          }
                        } else if (dateFrom !== undefined) {
                          if (new Date(el.createdAt) >= dateFrom) {
                            return (
                              <TableRow hover key={el.id}>
                                <TableCell sx={{ width: '20px' }}>
                                  <Button
                                    sx={{ color: '#C09A53' }}
                                    component={Link}
                                    to={`/details-pz04/${el.id}`}
                                  >
                                    <ReadMore />
                                  </Button>
                                </TableCell>
                                <TableCell>{el.reportNumber}</TableCell>
                                <TableCell>
                                  {handleChangeType(el.typeReport)}
                                </TableCell>
                                <TableCell>
                                  {changeFirstLetterToUpper(el.reason)}
                                </TableCell>
                                <TableCell>{el.orderNumber}</TableCell>
                                <TableCell>
                                  {el.orderProduct.materialNumber}
                                </TableCell>
                                <TableCell>
                                  {el.orderProduct.description}
                                </TableCell>
                                <TableCell>{el.orderBatch}</TableCell>
                                <TableCell>{el.BBT}</TableCell>
                                <TableCell>
                                  {el.microCulture ? 'Tak' : 'Nie'}
                                </TableCell>
                                <TableCell>
                                  {dateFormatter(el.createdAt)}
                                </TableCell>
                                {el.statusReport === 'DONE' && (
                                  <TableCell>
                                    <Chip
                                      label={changeStatusName(el.statusReport)}
                                      color="success"
                                    />
                                  </TableCell>
                                )}
                                {el.statusReport === 'IN_PROGRESS' && (
                                  <TableCell>
                                    <Chip
                                      label={changeStatusName(el.statusReport)}
                                      sx={{ backgroundColor: 'orange' }}
                                    />
                                  </TableCell>
                                )}
                                {el.statusReport === 'NEW' && (
                                  <TableCell>
                                    <Chip
                                      label={changeStatusName(el.statusReport)}
                                      color="primary"
                                    />
                                  </TableCell>
                                )}
                                {(user.users.role === 'LABO' ||
                                  user.users.role === 'ADMIN') && (
                                  <TableCell align="center">
                                    <Box display="flex">
                                      {(el.statusReport === 'NEW' ||
                                        user.users.role === 'ADMIN') && (
                                        <Button
                                          sx={{ color: 'orange', p: '0' }}
                                          component={Link}
                                          to={`/edit-pz04/${el.id}`}
                                        >
                                          <EditIcon />
                                        </Button>
                                      )}
                                      {(el.statusReport === 'NEW' ||
                                        user.users.role === 'ADMIN') && (
                                        <Button
                                          sx={{ color: 'red', p: '0' }}
                                          onClick={() => handleSubmit(el.id)}
                                        >
                                          <DeleteIcon />
                                        </Button>
                                      )}
                                    </Box>
                                  </TableCell>
                                )}
                              </TableRow>
                            );
                          }
                        } else {
                          return (
                            <TableRow hover key={el.id}>
                              <TableCell sx={{ width: '20px' }}>
                                <Button
                                  sx={{ color: '#C09A53' }}
                                  component={Link}
                                  to={`/details-pz04/${el.id}`}
                                >
                                  <ReadMore />
                                </Button>
                              </TableCell>
                              <TableCell>{el.reportNumber}</TableCell>
                              <TableCell>
                                {handleChangeType(el.typeReport)}
                              </TableCell>
                              <TableCell>
                                {changeFirstLetterToUpper(el.reason)}
                              </TableCell>
                              <TableCell>{el.orderNumber}</TableCell>
                              <TableCell>
                                {el.orderProduct.materialNumber}
                              </TableCell>
                              <TableCell>
                                {el.orderProduct.description}
                              </TableCell>
                              <TableCell>{el.orderBatch}</TableCell>
                              <TableCell>{el.BBT}</TableCell>
                              <TableCell>
                                {el.microCulture ? 'Tak' : 'Nie'}
                              </TableCell>
                              <TableCell>
                                {dateFormatter(el.createdAt)}
                              </TableCell>
                              {el.statusReport === 'DONE' && (
                                <TableCell>
                                  <Chip
                                    label={changeStatusName(el.statusReport)}
                                    color="success"
                                  />
                                </TableCell>
                              )}
                              {el.statusReport === 'IN_PROGRESS' && (
                                <TableCell>
                                  <Chip
                                    label={changeStatusName(el.statusReport)}
                                    sx={{ backgroundColor: 'orange' }}
                                  />
                                </TableCell>
                              )}
                              {el.statusReport === 'NEW' && (
                                <TableCell>
                                  <Chip
                                    label={changeStatusName(el.statusReport)}
                                    color="primary"
                                  />
                                </TableCell>
                              )}
                              {(user.users.role === 'LABO' ||
                                user.users.role === 'ADMIN') && (
                                <TableCell align="center">
                                  <Box display="flex">
                                    {(el.statusReport === 'NEW' ||
                                      user.users.role === 'ADMIN') && (
                                      <Button
                                        sx={{ color: 'orange', p: '0' }}
                                        component={Link}
                                        to={`/edit-pz04/${el.id}`}
                                      >
                                        <EditIcon />
                                      </Button>
                                    )}
                                    {(el.statusReport === 'NEW' ||
                                      user.users.role === 'ADMIN') && (
                                      <Button
                                        sx={{ color: 'red', p: '0' }}
                                        onClick={() => handleSubmit(el.id)}
                                      >
                                        <DeleteIcon />
                                      </Button>
                                    )}
                                  </Box>
                                </TableCell>
                              )}
                            </TableRow>
                          );
                        }
                      }
                    } else if (
                      (el.statusReport === 'NEW' && newReport) ||
                      (el.statusReport === 'IN_PROGRESS' && inProgressReport) ||
                      (el.statusReport === 'DONE' && doneReport)
                    ) {
                      if (dateFrom !== undefined && dateTo !== undefined) {
                        if (
                          new Date(el.createdAt) >= dateFrom &&
                          new Date(el.createdAt) <= dateTo
                        ) {
                          return (
                            <TableRow hover key={el.id}>
                              <TableCell sx={{ width: '20px' }}>
                                <Button
                                  sx={{ color: '#C09A53' }}
                                  component={Link}
                                  to={`/details-pz04/${el.id}`}
                                >
                                  <ReadMore />
                                </Button>
                              </TableCell>
                              <TableCell>{el.reportNumber}</TableCell>
                              <TableCell>
                                {handleChangeType(el.typeReport)}
                              </TableCell>
                              <TableCell>
                                {changeFirstLetterToUpper(el.reason)}
                              </TableCell>
                              <TableCell>{el.orderNumber}</TableCell>
                              <TableCell>
                                {el.orderProduct.materialNumber}
                              </TableCell>
                              <TableCell>
                                {el.orderProduct.description}
                              </TableCell>
                              <TableCell>{el.orderBatch}</TableCell>
                              <TableCell>{el.BBT}</TableCell>
                              <TableCell>
                                {el.microCulture ? 'Tak' : 'Nie'}
                              </TableCell>
                              <TableCell>
                                {dateFormatter(el.createdAt)}
                              </TableCell>
                              {el.statusReport === 'DONE' && (
                                <TableCell>
                                  <Chip
                                    label={changeStatusName(el.statusReport)}
                                    color="success"
                                  />
                                </TableCell>
                              )}
                              {el.statusReport === 'IN_PROGRESS' && (
                                <TableCell>
                                  <Chip
                                    label={changeStatusName(el.statusReport)}
                                    sx={{ backgroundColor: 'orange' }}
                                  />
                                </TableCell>
                              )}
                              {el.statusReport === 'NEW' && (
                                <TableCell>
                                  <Chip
                                    label={changeStatusName(el.statusReport)}
                                    color="primary"
                                  />
                                </TableCell>
                              )}
                              {(user.users.role === 'LABO' ||
                                user.users.role === 'ADMIN') && (
                                <TableCell align="center">
                                  <Box display="flex">
                                    {(el.statusReport === 'NEW' ||
                                      user.users.role === 'ADMIN') && (
                                      <Button
                                        sx={{ color: 'orange', p: '0' }}
                                        component={Link}
                                        to={`/edit-pz04/${el.id}`}
                                      >
                                        <EditIcon />
                                      </Button>
                                    )}
                                    {(el.statusReport === 'NEW' ||
                                      user.users.role === 'ADMIN') && (
                                      <Button
                                        sx={{ color: 'red', p: '0' }}
                                        onClick={() => handleSubmit(el.id)}
                                      >
                                        <DeleteIcon />
                                      </Button>
                                    )}
                                  </Box>
                                </TableCell>
                              )}
                            </TableRow>
                          );
                        }
                      } else if (dateTo !== undefined) {
                        if (new Date(el.createdAt) <= dateTo) {
                          return (
                            <TableRow hover key={el.id}>
                              <TableCell sx={{ width: '20px' }}>
                                <Button
                                  sx={{ color: '#C09A53' }}
                                  component={Link}
                                  to={`/details-pz04/${el.id}`}
                                >
                                  <ReadMore />
                                </Button>
                              </TableCell>
                              <TableCell>{el.reportNumber}</TableCell>
                              <TableCell>
                                {handleChangeType(el.typeReport)}
                              </TableCell>
                              <TableCell>
                                {changeFirstLetterToUpper(el.reason)}
                              </TableCell>
                              <TableCell>{el.orderNumber}</TableCell>
                              <TableCell>
                                {el.orderProduct.materialNumber}
                              </TableCell>
                              <TableCell>
                                {el.orderProduct.description}
                              </TableCell>
                              <TableCell>{el.orderBatch}</TableCell>
                              <TableCell>{el.BBT}</TableCell>
                              <TableCell>
                                {el.microCulture ? 'Tak' : 'Nie'}
                              </TableCell>
                              <TableCell>
                                {dateFormatter(el.createdAt)}
                              </TableCell>
                              {el.statusReport === 'DONE' && (
                                <TableCell>
                                  <Chip
                                    label={changeStatusName(el.statusReport)}
                                    color="success"
                                  />
                                </TableCell>
                              )}
                              {el.statusReport === 'IN_PROGRESS' && (
                                <TableCell>
                                  <Chip
                                    label={changeStatusName(el.statusReport)}
                                    sx={{ backgroundColor: 'orange' }}
                                  />
                                </TableCell>
                              )}
                              {el.statusReport === 'NEW' && (
                                <TableCell>
                                  <Chip
                                    label={changeStatusName(el.statusReport)}
                                    color="primary"
                                  />
                                </TableCell>
                              )}
                              {(user.users.role === 'LABO' ||
                                user.users.role === 'ADMIN') && (
                                <TableCell align="center">
                                  <Box display="flex">
                                    {(el.statusReport === 'NEW' ||
                                      user.users.role === 'ADMIN') && (
                                      <Button
                                        sx={{ color: 'orange', p: '0' }}
                                        component={Link}
                                        to={`/edit-pz04/${el.id}`}
                                      >
                                        <EditIcon />
                                      </Button>
                                    )}
                                    {(el.statusReport === 'NEW' ||
                                      user.users.role === 'ADMIN') && (
                                      <Button
                                        sx={{ color: 'red', p: '0' }}
                                        onClick={() => handleSubmit(el.id)}
                                      >
                                        <DeleteIcon />
                                      </Button>
                                    )}
                                  </Box>
                                </TableCell>
                              )}
                            </TableRow>
                          );
                        }
                      } else if (dateFrom !== undefined) {
                        if (new Date(el.createdAt) >= dateFrom) {
                          return (
                            <TableRow hover key={el.id}>
                              <TableCell sx={{ width: '20px' }}>
                                <Button
                                  sx={{ color: '#C09A53' }}
                                  component={Link}
                                  to={`/details-pz04/${el.id}`}
                                >
                                  <ReadMore />
                                </Button>
                              </TableCell>
                              <TableCell>{el.reportNumber}</TableCell>
                              <TableCell>
                                {handleChangeType(el.typeReport)}
                              </TableCell>
                              <TableCell>
                                {changeFirstLetterToUpper(el.reason)}
                              </TableCell>
                              <TableCell>{el.orderNumber}</TableCell>
                              <TableCell>
                                {el.orderProduct.materialNumber}
                              </TableCell>
                              <TableCell>
                                {el.orderProduct.description}
                              </TableCell>
                              <TableCell>{el.orderBatch}</TableCell>
                              <TableCell>{el.BBT}</TableCell>
                              <TableCell>
                                {el.microCulture ? 'Tak' : 'Nie'}
                              </TableCell>
                              <TableCell>
                                {dateFormatter(el.createdAt)}
                              </TableCell>
                              {el.statusReport === 'DONE' && (
                                <TableCell>
                                  <Chip
                                    label={changeStatusName(el.statusReport)}
                                    color="success"
                                  />
                                </TableCell>
                              )}
                              {el.statusReport === 'IN_PROGRESS' && (
                                <TableCell>
                                  <Chip
                                    label={changeStatusName(el.statusReport)}
                                    sx={{ backgroundColor: 'orange' }}
                                  />
                                </TableCell>
                              )}
                              {el.statusReport === 'NEW' && (
                                <TableCell>
                                  <Chip
                                    label={changeStatusName(el.statusReport)}
                                    color="primary"
                                  />
                                </TableCell>
                              )}
                              {(user.users.role === 'LABO' ||
                                user.users.role === 'ADMIN') && (
                                <TableCell align="center">
                                  <Box display="flex">
                                    {(el.statusReport === 'NEW' ||
                                      user.users.role === 'ADMIN') && (
                                      <Button
                                        sx={{ color: 'orange', p: '0' }}
                                        component={Link}
                                        to={`/edit-pz04/${el.id}`}
                                      >
                                        <EditIcon />
                                      </Button>
                                    )}
                                    {(el.statusReport === 'NEW' ||
                                      user.users.role === 'ADMIN') && (
                                      <Button
                                        sx={{ color: 'red', p: '0' }}
                                        onClick={() => handleSubmit(el.id)}
                                      >
                                        <DeleteIcon />
                                      </Button>
                                    )}
                                  </Box>
                                </TableCell>
                              )}
                            </TableRow>
                          );
                        }
                      } else {
                        return (
                          <TableRow hover key={el.id}>
                            <TableCell sx={{ width: '20px' }}>
                              <Button
                                sx={{ color: '#C09A53' }}
                                component={Link}
                                to={`/details-pz04/${el.id}`}
                              >
                                <ReadMore />
                              </Button>
                            </TableCell>
                            <TableCell>{el.reportNumber}</TableCell>
                            <TableCell>
                              {handleChangeType(el.typeReport)}
                            </TableCell>
                            <TableCell>
                              {changeFirstLetterToUpper(el.reason)}
                            </TableCell>
                            <TableCell>{el.orderNumber}</TableCell>
                            <TableCell>
                              {el.orderProduct.materialNumber}
                            </TableCell>
                            <TableCell>{el.orderProduct.description}</TableCell>
                            <TableCell>{el.orderBatch}</TableCell>
                            <TableCell>{el.BBT}</TableCell>
                            <TableCell>
                              {el.microCulture ? 'Tak' : 'Nie'}
                            </TableCell>
                            <TableCell>{dateFormatter(el.createdAt)}</TableCell>
                            {el.statusReport === 'DONE' && (
                              <TableCell>
                                <Chip
                                  label={changeStatusName(el.statusReport)}
                                  color="success"
                                />
                              </TableCell>
                            )}
                            {el.statusReport === 'IN_PROGRESS' && (
                              <TableCell>
                                <Chip
                                  label={changeStatusName(el.statusReport)}
                                  sx={{ backgroundColor: 'orange' }}
                                />
                              </TableCell>
                            )}
                            {el.statusReport === 'NEW' && (
                              <TableCell>
                                <Chip
                                  label={changeStatusName(el.statusReport)}
                                  color="primary"
                                />
                              </TableCell>
                            )}
                            {(user.users.role === 'LABO' ||
                              user.users.role === 'ADMIN') && (
                              <TableCell align="center">
                                <Box display="flex">
                                  {(el.statusReport === 'NEW' ||
                                    user.users.role === 'ADMIN') && (
                                    <Button
                                      sx={{ color: 'orange', p: '0' }}
                                      component={Link}
                                      to={`/edit-pz04/${el.id}`}
                                    >
                                      <EditIcon />
                                    </Button>
                                  )}
                                  {(el.statusReport === 'NEW' ||
                                    user.users.role === 'ADMIN') && (
                                    <Button
                                      sx={{ color: 'red', p: '0' }}
                                      onClick={() => handleSubmit(el.id)}
                                    >
                                      <DeleteIcon />
                                    </Button>
                                  )}
                                </Box>
                              </TableCell>
                            )}
                          </TableRow>
                        );
                      }
                    }
                  })}
            </TableBody>
          </Table>
        </TableContainer>
        <Box display="flex" justifyContent="center">
          <Pagination
            count={pageCount}
            page={activePage}
            onChange={handleChangePage}
          />
        </Box>
      </>
    );
  }
};

export default ReportPZ04ListForm;
